module.exports = __webpack_public_path__ + "img/35.4f67d376.jpg";